<template>
  <CRow>
    <CCol sm="12">
      <CCard>
        <CCardHeader
          class="w-100 d-flex justify-content-between align-items-center"
        >
          دانش‌آموزان
        </CCardHeader>
        <CCardBody class="h-100">
          <div class="d-flex align-items-center">
            <div>فیلتر:</div>
            <CSelect
              placeholder="پایه"
              class="CSelectStyle"
              @update:value="getKlasses"
              :options="computedGrades"
            />

            <CSelect
              placeholder="کلاس"
              class="CSelectStyle"
              @update:value="getStudents"
              :options="computedKlasses"
            />
          </div>
          <CRow>
            <CCol sm="12">
              <CDataTable
                class="w-100 d-flex justify-content-between h-100"
                :noItemsView="{
                  noItems: 'در حال حاضر محتوایی در این قسمت وجود ندارد',
                }"
                :items="computedStudents"
                :fields="studentField"
                hover
                striped
                border
                small
                fixed
              >
                <template #detail="{ item }">
                  <td>
                    <router-link :to="`/manager/student/${item.id}`">
                      <CButton
                        :disabled="loading"
                        color="success"
                        square
                        size="sm"
                        class="modal-button"
                      >
                        مشاهده
                      </CButton>
                    </router-link>
                    <router-view @go-to="goTo"></router-view>
                  </td>
                </template>
              </CDataTable>
              <ViewStudentModal
                v-model="studentViewModal"
                :user="selectedItem"
              />
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from "@/plugins/axios";
import ViewStudentModal from "@/components/Modals/User/ViewStudentModal.vue";

export default {
  components: { ViewStudentModal },
  name: "ManageStudent",
  data() {
    return {
      studentImageModal: false,
      studentDetailModal: false,
      selectedGrade: "",
      grades: [],
      klasses: [],
      students: [],
      studentField: [
        { key: "name", label: "نام" },
        { key: "lastname", label: "نام خانوادگی" },
        { key: "nationalId", label: "کد ملی" },
        { key: "fatherName", label: "نام پدر" },
        { key: "birthDate", label: "تارخ تولد" },
        { key: "mobile", label: "شماره تماس" },
        { key: "detail", label: "مشاهده" },
      ],
      studentViewModal: false,
      selectedItem: {},
    };
  },
  computed: {
    computedStudents() {
      return this.students.map((item) => {
        return {
          ...item,
          name: `${item.name}`,
          lastname: `${item.lastname}`,
          nationalId: `${item.nationalId}`,
          fatherName: `${item.fatherName}`,
          birthDate: `${item.birthDate}`,
          studentMobile: `${item.mobile}`,
          detail: "",
        };
      });
    },
    computedGrades() {
      return this.grades.map((item) => {
        return {
          ...item,
          value: `${item.id}`,
          label: `${item.name}`,
        };
      });
    },
    computedKlasses() {
      return this.klasses.map((item) => {
        return {
          value: `${item.id}`,
          label: `${item.name}`,
        };
      });
    },
  },
  mounted() {
    this.getGrades();
  },
  methods: {
    async getGrades() {
      try {
        this.loading = true;
        const { data } = await axios.get("/grade");
        this.grades = data;
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    async getKlasses(gradeId) {
      try {
        this.loading = true;
        this.klasses = [];
        const { data } = await axios.get(`/grade/${gradeId}/klass`);
        this.klasses = data;
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    async getActiveCourse() {
      try {
        this.loading = true;
        const { data } = await axios.get("/course/active");
        this.activeCourses = data;
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    async getStudents(klassId) {
      try {
        this.loading = true;
        const { data } = await axios.get(`/student`, {
          params: {
            klassId: klassId,
          },
        });
        this.students = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    onStudentViewModal(item) {
      this.selectedItem = item;
      this.studentViewModal = true;
    },
    goTo(item, routeName) {
      routeName = `${item.name} ${item.lastname}`;
      this.$emit("go-to", routeName);
    },
  },
};
</script>

<style lang="scss" scoped>
.CSelectStyle {
  margin: 0px 8px 8px 0px;
}
</style>
